import { render, staticRenderFns } from "./page.vue?vue&type=template&id=030e9408&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=030e9408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e9408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030e9408')) {
      api.createRecord('030e9408', component.options)
    } else {
      api.reload('030e9408', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=030e9408&scoped=true&", function () {
      api.rerender('030e9408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/entries/co-pilot/routes/overview/page.vue"
export default component.exports